<div class="site">
  @if (!onCrm() && market.quotes().length) {
    <div class="tape" aria-hidden="true">
      <div class="tape-track">
        @for (quote of tape(); track $index) {
          <a [routerLink]="['/trade', quote.symbol]" tabindex="-1">
            <b>{{ quote.symbol }}</b>
            <span>{{ price(quote.price, quote.precision) }}</span>
            <em [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</em>
          </a>
        }
      </div>
    </div>
  }

  @if (!onCrm()) {
  <header class="nav">
    <a class="brand" routerLink="/" (click)="closeMenu()">
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <path d="M21.6 7.4a10 10 0 1 0 .15 17.2" />
        <path d="M15.2 19.4 20.4 13.2 22.8 15.4 27.4 9" />
      </svg>
      <span class="brand-name">Capi<em>Trade</em></span>
    </a>
    <button class="nav-toggle" type="button" (click)="menuOpen.set(!menuOpen())" [attr.aria-expanded]="menuOpen()">
      {{ menuOpen() ? lang.t('close') : lang.t('menu') }}
    </button>
    <nav [class.open]="menuOpen()">
      <div class="nav-links">
        <div class="nav-drop" (mouseenter)="hoverDrop('trade', $event)" (mouseleave)="leaveDrop()">
          <button type="button" class="nav-drop-btn" [class.open]="openDrop() === 'trade'" [attr.aria-expanded]="openDrop() === 'trade'" (click)="toggleDrop('trade', $event)">
            {{ lang.t('trade') }}
            <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
          </button>
          @if (openDrop() === 'trade') {
            <div class="nav-panel" [style.top.px]="dropTop()" (mouseenter)="stayDrop()" (mouseleave)="leaveDrop()">
              <div>
                <p>{{ lang.t('navProducts') }}</p>
                <a routerLink="/markets" [queryParams]="{ class: 'EQUITY' }" (click)="closeMenu()"><strong>{{ lang.t('navEquities') }}</strong><span>{{ lang.t('navEquitiesSub') }}</span></a>
                <a routerLink="/markets" [queryParams]="{ class: 'INDEX' }" (click)="closeMenu()"><strong>{{ lang.t('navIndexes') }}</strong><span>{{ lang.t('navIndexesSub') }}</span></a>
                <a routerLink="/markets" [queryParams]="{ class: 'CRYPTO' }" (click)="closeMenu()"><strong>{{ lang.t('navCrypto') }}</strong><span>{{ lang.t('navCryptoSub') }}</span></a>
                <a routerLink="/markets" [queryParams]="{ class: 'FX' }" (click)="closeMenu()"><strong>{{ lang.t('navFx') }}</strong><span>{{ lang.t('navFxSub') }}</span></a>
                <a routerLink="/markets" [queryParams]="{ class: 'COMMODITY' }" (click)="closeMenu()"><strong>{{ lang.t('navMetals') }}</strong><span>{{ lang.t('navMetalsSub') }}</span></a>
              </div>
              <div>
                <p>{{ lang.t('navAi') }}</p>
                <a routerLink="/markets" (click)="closeMenu()"><strong>{{ lang.t('navAll') }}</strong><span>{{ lang.t('navAllSub') }}</span></a>
                <a routerLink="/" fragment="resources" (click)="closeMenu()"><strong>{{ lang.t('navPractice') }}</strong><span>{{ lang.t('navPracticeSub') }}</span></a>
              </div>
              <div>
                <p>{{ lang.t('navPlatform') }}</p>
                <a routerLink="/" fragment="platform" (click)="closeMenu()"><strong>{{ lang.t('navRead') }}</strong><span>{{ lang.t('navReadSub') }}</span></a>
                @if (auth.signedIn()) {
                  <a routerLink="/profile" (click)="closeMenu()"><strong>{{ lang.t('navYours') }}</strong><span>{{ lang.t('navYoursIn') }}</span></a>
                } @else {
                  <a routerLink="/signup" (click)="closeMenu()"><strong>{{ lang.t('navYours') }}</strong><span>{{ lang.t('navYoursOut') }}</span></a>
                }
              </div>
            </div>
          }
        </div>
        <div class="nav-drop" (mouseenter)="hoverDrop('accounts', $event)" (mouseleave)="leaveDrop()">
          <button type="button" class="nav-drop-btn" [class.open]="openDrop() === 'accounts'" [attr.aria-expanded]="openDrop() === 'accounts'" (click)="toggleDrop('accounts', $event)">
            {{ lang.t('tradingAccounts') }}
            <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
          </button>
          @if (openDrop() === 'accounts') {
            <div class="nav-panel slim" [style.top.px]="dropTop()" [style.left.px]="dropLeft()" (mouseenter)="stayDrop()" (mouseleave)="leaveDrop()">
              <div>
                <p>{{ lang.t('navAcc') }}</p>
                <a routerLink="/accounts" (click)="closeMenu()"><strong>{{ lang.t('navOverview') }}</strong><span>{{ lang.t('navOverviewSub') }}</span></a>
                @if (auth.signedIn()) {
                  <a routerLink="/portfolio" (click)="closeMenu()"><strong>{{ lang.t('portfolio') }}</strong><span>{{ lang.t('navPortSub') }}</span></a>
                  <a routerLink="/profile" (click)="closeMenu()"><strong>{{ lang.t('navYours') }}</strong><span>{{ lang.t('navYoursIn') }}</span></a>
                } @else {
                  <a routerLink="/signup" (click)="closeMenu()"><strong>{{ lang.t('openAccount') }}</strong><span>{{ lang.t('navOpenSub') }}</span></a>
                  <a routerLink="/signin" (click)="closeMenu()"><strong>{{ lang.t('signin') }}</strong><span>{{ lang.t('navSignSub') }}</span></a>
                }
              </div>
            </div>
          }
        </div>
        <div class="nav-drop" (mouseenter)="hoverDrop('resources', $event)" (mouseleave)="leaveDrop()">
          <button type="button" class="nav-drop-btn" [class.open]="openDrop() === 'resources'" [attr.aria-expanded]="openDrop() === 'resources'" (click)="toggleDrop('resources', $event)">
            {{ lang.t('resources') }}
            <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
          </button>
          @if (openDrop() === 'resources') {
            <div class="nav-panel slim" [style.top.px]="dropTop()" [style.left.px]="dropLeft()" (mouseenter)="stayDrop()" (mouseleave)="leaveDrop()">
              <div>
                <p>{{ lang.t('resources') }}</p>
                <a routerLink="/" fragment="resources" (click)="closeMenu()"><strong>{{ lang.t('fourSteps') }}</strong><span>{{ lang.t('navFourSub') }}</span></a>
                <a routerLink="/markets" (click)="closeMenu()"><strong>{{ lang.t('marketList') }}</strong><span>{{ lang.t('navListSub') }}</span></a>
                <button type="button" (click)="openTouch()"><strong>{{ lang.t('support') }}</strong><span>{{ lang.t('navSupportSub') }}</span></button>
              </div>
            </div>
          }
        </div>
        <div class="nav-drop" (mouseenter)="hoverDrop('company', $event)" (mouseleave)="leaveDrop()">
          <button type="button" class="nav-drop-btn" [class.open]="openDrop() === 'company'" [attr.aria-expanded]="openDrop() === 'company'" (click)="toggleDrop('company', $event)">
            {{ lang.t('company') }}
            <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
          </button>
          @if (openDrop() === 'company') {
            <div class="nav-panel slim" [style.top.px]="dropTop()" [style.left.px]="dropLeft()" (mouseenter)="stayDrop()" (mouseleave)="leaveDrop()">
              <div>
                <p>{{ lang.t('company') }}</p>
                <a routerLink="/" fragment="company" (click)="closeMenu()"><strong>{{ lang.t('theAi') }}</strong><span>{{ lang.t('navAiSub') }}</span></a>
                <a routerLink="/" fragment="clients" (click)="closeMenu()"><strong>{{ lang.t('clients') }}</strong><span>{{ lang.t('navClientsSub') }}</span></a>
                <button type="button" (click)="openTouch()"><strong>{{ lang.t('getInTouch') }}</strong><span>{{ lang.t('navTelegram') }}</span></button>
              </div>
            </div>
          }
        </div>
        <div class="nav-drop" (mouseenter)="hoverDrop('ai', $event)" (mouseleave)="leaveDrop()">
          <button type="button" class="nav-drop-btn" [class.open]="openDrop() === 'ai'" [attr.aria-expanded]="openDrop() === 'ai'" (click)="toggleDrop('ai', $event)">
            {{ lang.t('ai') }}
            <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
          </button>
          @if (openDrop() === 'ai') {
            <div class="nav-panel slim" [style.top.px]="dropTop()" [style.left.px]="dropLeft()" (mouseenter)="stayDrop()" (mouseleave)="leaveDrop()">
              <div>
                <p>{{ lang.t('ai') }}</p>
                <a routerLink="/" fragment="platform" (click)="closeMenu()"><strong>{{ lang.t('navTheRead') }}</strong><span>{{ lang.t('navTheReadSub') }}</span></a>
                <a routerLink="/" fragment="resources" (click)="closeMenu()"><strong>{{ lang.t('navHowStarts') }}</strong><span>{{ lang.t('navHowStartsSub') }}</span></a>
              </div>
            </div>
          }
        </div>
        @if (auth.signedIn()) {
          <a routerLink="/portfolio" routerLinkActive="active" (click)="closeMenu()">{{ lang.t('portfolio') }}</a>
        }
      </div>
      <div class="nav-end">
        <form class="nav-search" (submit)="onSearch($event, jump)">
          <label class="sr" for="jump">{{ lang.t('jump') }}</label>
          <svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="4.25" /><path d="M10.2 10.2 13.5 13.5" /></svg>
          <input id="jump" #jump type="search" [placeholder]="lang.t('symbol')" autocomplete="off" (input)="onSearchInput(jump.value)" (focus)="openSearch()" />
          @if (searchOpen()) {
            <div class="nav-search-list">
              @for (quote of matches(); track quote.symbol) {
                <button type="button" (click)="pickSymbol(quote.symbol, jump)">
                  <strong>{{ quote.symbol }}</strong>
                  <span>{{ quote.name }}</span>
                </button>
              } @empty {
                <p>{{ lang.t('noMatch') }}</p>
              }
            </div>
          }
        </form>
        <a class="nav-lang" routerLink="/languages" (click)="closeMenu()" [attr.aria-label]="lang.t('selectLanguage')">
          <img class="nav-flag" [src]="lang.flagSrc(lang.current().flag)" alt="" width="22" height="16" />
          {{ lang.current().short }}
        </a>
        <button class="nav-contact" type="button" (click)="openTouch()">{{ lang.t('getInTouch') }}</button>
        @if (auth.signedIn()) {
          <div class="nav-account" (mouseenter)="hoverDrop('account', $event)" (mouseleave)="leaveDrop()">
            <button type="button" class="nav-account-btn" [class.open]="openDrop() === 'account'" [attr.aria-expanded]="openDrop() === 'account'" (click)="toggleDrop('account', $event)">
              <span class="nav-avatar" aria-hidden="true">{{ initials() }}</span>
              <span class="nav-account-copy">
                @if (auth.user(); as user) {
                  <strong>{{ user.name }}</strong>
                  <em>{{ money(user.cash) }}</em>
                } @else {
                  <strong>{{ lang.t('account') }}</strong>
                }
              </span>
              <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
            </button>
            @if (openDrop() === 'account') {
              <div class="nav-account-menu" (mouseenter)="stayDrop()" (mouseleave)="leaveDrop()">
                <div>
                  <a routerLink="/portfolio" (click)="closeMenu()">{{ lang.t('portfolio') }}</a>
                  <a routerLink="/profile" (click)="closeMenu()">{{ lang.t('account') }}</a>
                  <button type="button" (click)="signOut()">{{ lang.t('signOut') }}</button>
                </div>
              </div>
            }
          </div>
        } @else {
          <a class="nav-contact" routerLink="/signin" routerLinkActive="active" (click)="closeMenu()">{{ lang.t('signin') }}</a>
          <a class="nav-cta" routerLink="/signup" (click)="closeMenu()">{{ lang.t('openAccount') }}</a>
        }
      </div>
    </nav>
  </header>
  }

  <main [class.crm-main]="onCrm()">
    <router-outlet />
  </main>

  @if (!onCrm()) {
  <footer class="foot">
    <div class="foot-top">
      <div class="foot-brand">
        <a class="brand" routerLink="/" (click)="closeMenu()">
          <svg viewBox="0 0 32 32" aria-hidden="true">
            <path d="M21.6 7.4a10 10 0 1 0 .15 17.2" />
            <path d="M15.2 19.4 20.4 13.2 22.8 15.4 27.4 9" />
          </svg>
          <span class="brand-name">Capi<em>Trade</em></span>
        </a>
        <p>{{ lang.t('footBlurb') }}</p>
        @if (!auth.signedIn()) {
          <a class="foot-cta" routerLink="/signup" (click)="closeMenu()">{{ lang.t('openAccount') }}</a>
        }
      </div>
      <div class="foot-cols">
        <div>
          <strong>{{ lang.t('platform') }}</strong>
          <a routerLink="/markets" (click)="closeMenu()">{{ lang.t('markets') }}</a>
          <a routerLink="/" fragment="platform" (click)="closeMenu()">{{ lang.t('bot') }}</a>
          <a routerLink="/accounts" (click)="closeMenu()">{{ lang.t('fees') }}</a>
          <a routerLink="/" fragment="platform" (click)="closeMenu()">{{ lang.t('security') }}</a>
        </div>
        <div>
          <strong>{{ lang.t('learn') }}</strong>
          <a routerLink="/" fragment="resources" (click)="closeMenu()">{{ lang.t('how') }}</a>
          <a routerLink="/" fragment="resources" (click)="closeMenu()">{{ lang.t('academy') }}</a>
          <a routerLink="/" fragment="clients" (click)="closeMenu()">{{ lang.t('blog') }}</a>
          <a routerLink="/faqs" (click)="closeMenu()">{{ lang.t('faq') }}</a>
        </div>
        <div>
          <strong>{{ lang.t('company') }}</strong>
          <a routerLink="/" fragment="company" (click)="closeMenu()">{{ lang.t('about') }}</a>
          <button type="button" (click)="openTouch()">{{ lang.t('contact') }}</button>
          <button type="button" (click)="openTouch()">{{ lang.t('support') }}</button>
          <a routerLink="/signin" (click)="closeMenu()">{{ lang.t('signin') }}</a>
        </div>
      </div>
      <div class="foot-contact">
        <strong>{{ lang.t('contact') }}</strong>
        <p>support@capitrade.net</p>
        <p>{{ lang.t('footHours') }}</p>
        <p>First Floor Kgabo Mashego, Eremomela Avenue , 1749, South Africa</p>
        <div class="foot-social">
          <a href="https://t.me/CapiTradeAI_bot" target="_blank" rel="noopener">Telegram</a>
        </div>
      </div>
    </div>
    <div class="foot-legal">
      <p>{{ lang.t('footRisk') }} <a routerLink="/legal/risk" (click)="closeMenu()">{{ lang.t('footRiskLink') }}</a></p>
      <p>{{ lang.t('footInfo') }}</p>
      <p>{{ lang.t('footOperator') }}</p>
    </div>
    <div class="foot-bar">
      <p>© {{ year() }} CapiTrade. {{ lang.t('footRights') }}</p>
      <nav [attr.aria-label]="lang.t('footPolicies')">
        <a routerLink="/legal/terms" (click)="closeMenu()">{{ lang.t('footTerms') }}</a>
        <a href="/privacy-policy.pdf" target="_blank" rel="noopener" (click)="closeMenu()">{{ lang.t('footPrivacy') }}</a>
        <a routerLink="/legal/cookies" (click)="closeMenu()">{{ lang.t('footCookies') }}</a>
        <a routerLink="/legal/aml" (click)="closeMenu()">{{ lang.t('footAml') }}</a>
        <a routerLink="/legal/risk" (click)="closeMenu()">{{ lang.t('footRiskName') }}</a>
      </nav>
    </div>
  </footer>
  }
</div>

@if (!onCrm() && touchOpen()) {
  <div class="touch-pop" (click)="closeTouch()">
    <div class="touch-card" role="dialog" aria-modal="true" aria-labelledby="touch-title" (click)="$event.stopPropagation()">
      <button class="touch-x" type="button" (click)="closeTouch()" [attr.aria-label]="lang.t('close')">{{ lang.t('close') }}</button>
      <p class="kicker light">{{ lang.t('talkKicker') }}</p>
      <h2 id="touch-title">{{ lang.t('talkTitle') }}</h2>
      <p>{{ lang.t('talkBody') }}</p>
      <div class="touch-actions">
        <a class="touch-btn tg" href="https://t.me/CapiTradeAI_bot" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 32 32" aria-hidden="true">
            <circle cx="16" cy="16" r="11.5" />
            <path d="M9.2 15.6 22.4 10.4c.6-.2 1.1.2.9.9l-2.1 10c-.1.6-.6.8-1.1.5l-3.1-2.3-1.5 1.5c-.2.2-.4.3-.7.2l.3-3.2 6.4-5.8c.3-.3 0-.4-.4-.2l-7.9 5-3.4-1.1c-.7-.2-.7-.7-.1-.9Z" />
          </svg>
          <span><strong>Telegram</strong></span>
        </a>
      </div>
    </div>
  </div>
}

@if (!onCrm()) {
  <app-desk-assistant />
}

@if (toast.message(); as message) {
  <button type="button" class="toast" [class.bad]="toast.tone() === 'bad'" (click)="toast.dismiss()">{{ message }}</button>
}
